<template>
	<div class="container">

		<payoff />
		<!-- <why-to-choose
			id="more"
		/> -->

		<div class="feedaty-banner tag-partner" :class="{'' : $mq.isDesktop(), 'd-none' : !$mq.isDesktop()}">
			<div class="feedaty_widget" data-ver="2021" data-id="6220a211b3fc4" data-type="carousel" data-variant="carosello-1" data-lang="all" data-gui="all"></div>
		</div>

		<div class="feedaty-banner tag-partner" :class="{'' : !$mq.isDesktop(), 'd-none' : $mq.isDesktop()}">
			<div class="feedaty_widget" data-type="merchant" data-id="selettore1" data-variant="300x200-4" data-gui="all" data-lang="all" ></div>
		</div>

		<section id="slider" v-if='recipes && recipes.length > 0'>
			<h2 class="center">Un nuovo menù ogni settimana!</h2>
            <h3
                class="center"
                style='font-size:20px;font-weight: 300'
            >
              Ogni settimana ricette per soddisfare tutti i gusti. Tante idee, zero stress e zero sprechi.

            </h3>
            <br><br>

            <SliderQ
                :minSizeOfSlide="170"
                :maxNumSlides='4'
                isCentered
            >
                <slide
                	v-for="(recipe, index) in recipes"
                	v-if="menu"
                >
                	<recipe-box
											:homeSlider="true"
	                    :item="recipe"
	                    isHover
	                    isBoxWithLink
	                />
	            </slide>
            </SliderQ>
            <br>
            <router-link :to="{name: 'flow-subscribed'}" class="flex flex-center">
            	<CTA
					:content="`Ordina ora`"
					isArrow
				/>
			</router-link>
			<br>
		</section>

		<!-- <what-we-offer /> -->

		<how-quomi-works :altVersion="true" />

		<router-link :to="{name: 'flow-subscribed'}" class="flex flex-center">
			<CTA
				:content="`Ordina ora`"
				isArrow
			/>
		</router-link>
		
		<!-- <section id="opinions">
		<br>
			<opinions
					:template="'home'"
			/>
    </section> -->

		<section id="suppliers" class="flex col-12" style="padding: 0">
			<div class="box-img">

			</div>
			<div class="box">
				<h2 class="center">Cucinare con Quomi è sostenibile e conveniente!</h2>
				<br>
				<ul>
					<li class="text-bold"><img src="https://api.quomi.it/oldimg/waste.png" class="pr-3" loading="lazy"/> Riduci gli sprechi di cibo</li>
					<li>Con Quomi ricevi i tuoi ingredienti nelle giuste dosi e contribuisci a ridurre lo spreco di cibo.</li>
					<li class="text-bold"><img src="https://api.quomi.it/oldimg/get-money.png" class="pr-3" loading="lazy"/> Qualità al miglior prezzo</li>
					<li>Ricevi a casa prodotti selezionati di alta qualità direttamente dai produttori. </li>
					<li class="text-bold"><img src="https://api.quomi.it/oldimg/leaf-%281%29.png" class="pr-3" loading="lazy"/> Sostenibile per davvero</li>
					<li>Non solo meno sprechi di cibo e una filiera corta, ma anche un packaging riciclabile e un albero piantato ad ogni ordine!</li>
				</ul>
				<router-link :to="{name: 'flow-subscribed'}" class='flex flex-center'>
					<CTA
						:content="`Ordina ora`"
						isArrow
					/>
				</router-link>
			</div>
		</section> 

    <!-- <section id="what-in-box">
			<div class="box-outer">
				<div class="box">
					<h2>La Food Box Quomi è:</h2>
					<br>
					<ul>
						<li>Ricette con ingredienti stagionali</li>
						<li>Schede ricette illustrate</li>
						<li>Non solo cene ma anche tanti prodotti per colazioni, pranzi e snack</li>
						<li class="last">Un abbonamento settimanale flessibile o in acquisto singolo</li>
					</ul>
					<router-link :to="{name: 'flow-subscribed'}" class='flex flex-center'>
						<CTA
							:content="`Fai la tua spesa`"
							isArrow
						/>
					</router-link>
					<div
						class="info-small"
						v-html="`Già scelto da migliaia di persone`"
					/>
				</div>
			</div>
		</section> -->

		<what-they-say />

		<v-expansion-panels tile>
			<v-expansion-panel  style="background: var(--quomi-primary); color: white">
				<v-expansion-panel-header hide-actions class="flex flex-column text-center" style="margin: 0 auto; color: white; outline: none">
					<h2>Quomi Spesa Online</h2>
					<p style="line-height: 1.5">Quomi è il rivoluzionario e-commerce dove puoi fare la spesa online acquistando prodotti freschi e di stagione direttamente dai nostri produttori selezionati, ricevendo la tua food box direttamente a casa grazie al nostro servizio di consegna a domicilio...</p>
					<span style="text-decoration: underline">Leggi tutto</span>
				</v-expansion-panel-header>
				<v-expansion-panel-content class="text-center" style="margin: 0 auto">
					Su Quomi puoi ordinare i kit ricette, completi di tutti gli ingredienti freschi e dosati in base al numero di persone scelto. In più ricevi anche la scheda ricetta, con le istruzioni per cucinare passo passo!
					I prodotti che trovi su Quomi sono artigianali e di stagione, e vengono spediti con imballaggi riciclabili per rispettare al massimo l'ambiente. La lotta allo spreco di cibo grazie ai kit ricette dosati e la filiera più corta fanno di Quomi un servizio di spesa online davvero sostenibile.
					In aggiunta puoi anche acquistare le nostre Cassette di frutta e verdura a domicilio, oppure fare la spesa online aggiungendo al tuo carrello i prodotti che preferisci: frutta e verdura, carne, pesce, latticini, pasta fresca, pane, piatti pronti, ma anche prodotti biologici, vini, birre, kit aperitivo, kit pizza e molto altro!
					Il servizio con consegna a domicilio è attivo in quasi tutta Italia, e in alcune zone è possibile scegliere anche le fasce orarie di consegna.
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

	</div>
</template>

<script>
import BannerGreeting from '../Parts/BannerGreeting'
import HowQuomiWorks from '../Parts/HowQuomiWorks'
import StartWithUs from '../Parts/StartWithUs'
import WhatTheySay from '../Parts/WhatTheySay'
import WhyToChoose from '../Parts/WhyToChoose'
import Payoff from '../Parts/Payoff'
import WhatWeOffer from '../Parts/WhatWeOffer'
import { RecipeApi } from '../../api/RecipeApi'
import { Recipe } from '../../core/Recipe'

import { container } from '../../services/container' 
import { menuStore } from '../../store/menuStore' 

import RecipeBox from '../RecipeBox'
import Opinions from '../Opinions'
import Usp from '../Usp'

export default {
	data () {
		return {
			menuStore: menuStore.state,

			electolux: true
		}
	},

	components: {
		BannerGreeting,
		HowQuomiWorks,
		WhyToChoose,
		WhatTheySay,
		WhatWeOffer,
		RecipeBox,
		Opinions,
		Payoff,
		Usp,
	},

	computed: {
		menu () {
			return this.menuStore.menu
		},

		user () {
			return this.$root.user
		},

		recipes () {
			return this.menuStore.menu && this.menuStore.menu.recipes
		}
	},

	methods: {
		load () {
			menuStore.loadCurrentMenu()
		},

		openRecipe (id) {
			this.loadSingleRecipe({ id: id })

			.then(response => {
				this.openRecipePage({ recipe: response.body.data.resource })
			})
		},

		loadSingleRecipe(params) {
			var rm = new RecipeApi()
			return rm.recipe(params.id)
		},

		openRecipePage (params) {
			var recipe = new Recipe(params.recipe)
			var url = recipe.url ? recipe.url : recipe.id
			this.$router.push({ name: 'recipe', params: { id: url } })
		}
	},

	mounted () {
		const feedatyPlugin = document.createElement("script");
		feedatyPlugin.setAttribute("src", "https://widget.feedaty.com/public/js/feedaty.js?merchant=10214294&style_ver=2021");
		feedatyPlugin.async = true;
		document.head.appendChild(feedatyPlugin);
		
		this.load()
	}
}

</script>

<style scoped>

.feedaty-banner {
	display: flex;
	justify-content: center;
	background: var(--quomi-bg);
	padding-top: 20px;
	padding-bottom: 20px;
}

section {
	padding: 40px 30px;
}

.flex-listing {
	max-width: 1240px;
	margin-left: auto;
	margin-right: auto;
}

/* #what-in-box {
	background-image: url("../../assets/img/covers/cover-box.jpg");
} */

/* #what-in-box, */
#suppliers {
	background-color: #ededed;
	width: 100vw;
	height: 550px;
	margin: 30px 0;
}

/* #suppliers {
	background-position: 90% 0;
	background-image: url("https://api.quomi.it/oldimg/Cucina-senza-sprechi-con-Quomi.webp");
} */

/* #what-in-box .box-outer, */
#suppliers .box-img {
	width: 50vw;
	background-size: cover;
	background-position: 90% 0;
	background-image: url("https://api.quomi.it/oldimg/Cucina-senza-sprechi-con-Quomi.webp");
}

/* #what-in-box .box, */
#suppliers .box {
	text-align: center;
	background: #f8f8f8;
	color: #575A5C;
	padding: 30px 30px;
	width: 50vw;
	height: 550px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

/* #what-in-box .box li, */
#suppliers .box li {
	padding: 10px 0;
	text-align: left;
	position: relative;
}

/* #what-in-box .box ul, */
#suppliers .box ul {
	list-style: none;
	margin-left: 10px 20px;
}

/* #what-in-box .box ul li:before, */
/* #suppliers .box ul li:before {
	content: '\f00c';
	font-family: 'FontAwesome';
	margin-right: 5px;
	color: #9ec83b;
	position: absolute;
	left: -20px;
} */

/* #what-in-box .box li:last-child,  */
#suppliers .box li:last-child {
	margin-bottom: 30px;
}

.info-small {
	color: #9a9a9a;
	font-size: 13px;
}

@media only screen and (max-width: 1024px) {
	h2 {
		font-weight: bold;
	}

	.feedaty-banner {
		padding-top: 40px;
		padding-bottom: 20px;
	}

}

@media (max-width: 648px) {
	#suppliers {
		flex-direction: column;
	}

	#suppliers .box-img {
	width: 100%;
	height: 350px;
	}

	#suppliers .box {
	padding: 30px 30px;
	width: 100%;
	}
}

@media (max-width: 1024px) {
	#suppliers,
	#suppliers .box {
		height: unset;
	}

	#suppliers .box {
		border-radius: 5px ;
		max-width: 550px;
	}
}
</style>

<style>
#fdt_6220a211b3fc4_widget_merchant {
	background: unset !important;
}

.fdt_merchant300x200-4_widget_merchant {
	background: unset !important;
	border: unset !important;
}
</style>
